import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ role }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (role && user?.role !== role) {
    const fallback = user?.role === 'admin' ? '/dashboard/admin' : '/dashboard/member';
    return <Navigate to={fallback} replace />;
  }

  return <Outlet />;
}
